module.exports = __webpack_public_path__ + "static/media/qrcode.37314975.jpg";